import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
    page: 0,
    rowsPerPage: 25,
    userPage: 0,
    userRowsPerPage: 25,
    isLoading: false,
    isLoadingForAddress: false,
    message: '',
    branch: [],
    branchesUsers: [],
    userDetails: {},
    branchDetails: {},
    branchAddressList: []
};

const slice = createSlice({
    name: 'branch',
    initialState,
    reducers: {
        // Pagination
        setPage(state, action) {
            state.page = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setUserPage(state, action) {
            state.userPage = action.payload;
        },
        setUserRowsPerPage(state, action) {
            state.userRowsPerPage = action.payload;
        },
        startAddingNewBranch(state) {
            state.isLoading = true;
        },
        startDynamicFilter(state) {
            state.isLoading = true;
        },
        startAllBranch(state) {
            state.isLoading = true;
        },
        setBranches(state, action) {
            state.branch = action.payload;
        },
        startUsersByBranchId(state) {
            state.isLoading = true;
        },
        setBranchUsers(state, action) {
            state.branchesUsers = action.payload;
        },
        startBranchDetailsOnID(state) {
            state.isLoading = true;
        },
        branchDetails(state, action) {
            state.branchDetails = action.payload;
        },
        startDeleteBranch(state) {
            state.isLoading = true;
        },
        completedAction(state) {
            state.isLoading = false;
            state.isLoadingForAddress = false;
        },
        startAddingBranchUser(state) {
            state.isLoading = true;
        },
        startUpdatingBranchUser(state) {
            state.isLoading = true;
        },
        startBranchUserData(state) {
            state.isLoading = true;
        },
        setBranchUserData(state, action) {
            state.userDetails = action.payload;
        },
        startBranchAddressList(state) {
            state.isLoadingForAddress = true;
        },
        setBranchAddressList(state, action) {
            state.branchAddressList = action.payload;
        },
        startAddOrEditAddress(state) {
            state.isLoadingForAddress = true;
        }
    }
});

export const {
    setPage,
    setRowsPerPage,
    setUserPage,
    setUserRowsPerPage,
    startDeleteBranch,
    startUsersByBranchId,
    setBranchUsers,
    setBranches,
    startAllBranch,
    completedAction,
    startAddingNewBranch,
    branchDetails,
    startBranchDetailsOnID,
    startAddingBranchUser,
    startDynamicFilter,
    setBranchUserData,
    startBranchUserData,
    startUpdatingBranchUser,
    startBranchAddressList,
    setBranchAddressList,
    startAddOrEditAddress
} = slice.actions;

export default slice.reducer;

const branchStates = (state) => state.branch;

export const isLoadingSelector = createSelector([branchStates], (branchDataState) => branchDataState?.isLoading);
export const isLoadingForAddressSelector = createSelector([branchStates], (branchDataState) => branchDataState?.isLoadingForAddress);
export const branchDetailsSelector = createSelector([branchStates], (branchDataState) => branchDataState?.branchDetails);
export const branchAddressListSelector = createSelector([branchStates], (branchDataState) => branchDataState?.branchAddressList);
export const branchesSelector = createSelector([branchStates], (branchDataState) => branchDataState?.branch);
export const branchUsersSelector = createSelector([branchStates], (branchDataState) => branchDataState?.branchesUsers);
export const pageSelector = createSelector([branchStates], (branchDataState) => branchDataState?.page);
export const rowsPerPageSelector = createSelector([branchStates], (branchDataState) => branchDataState?.rowsPerPage);
export const userPageSelector = createSelector([branchStates], (branchDataState) => branchDataState?.userPage);
export const userRowsPerPageSelector = createSelector([branchStates], (branchDataState) => branchDataState?.userRowsPerPage);
